import { render } from "./FormSubmitButton.vue?vue&type=template&id=7eeed970"
import script from "./FormSubmitButton.vue?vue&type=script&lang=js"
export * from "./FormSubmitButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__